// TODO: V Replace this component with all our base inputs as this contains the new design

import { BaseInput, type IProps } from '@/src/components'
import type { InputProps } from '@chakra-ui/react'

interface IFormInput extends InputProps {
  name: string
  label?: string
  disabled?: boolean
  infoTooltip?: string
  maxLength?: number
  errorMessage?: string
  labelFontSize?: string
  labelFontColor?: string
  labelFontWeight?: string
  fontWeight?: string | number
  color?: string
}

export const FormInput = ({
  name,
  label,
  value,
  width,
  disabled,
  infoTooltip,
  maxLength,
  errorMessage,
  labelFontSize,
  labelFontColor,
  labelFontWeight,
  fontWeight,
  color,
  ...props
}: IFormInput & IProps) => {
  return (
    <BaseInput
      name={name}
      value={value}
      label={label}
      labelFontSize={labelFontSize || '12px'}
      labelFontColor={labelFontColor || 'gray.600'}
      labelFontWeight={labelFontWeight || '400'}
      width={width}
      variant='unstyled'
      height={'32px'}
      disabled={disabled}
      backgroundColor={'white'}
      fontSize='14px'
      fontWeight={fontWeight || 400}
      color={`${disabled ? '#656565' : color ?? '#0D0D0D'}`}
      textAlign='left'
      /* @ts-ignore */
      paddingRight={'10px'}
      maxLength={maxLength}
      blackInfoIcon={true}
      showInfo={!!infoTooltip}
      helperText={infoTooltip}
      errorMessage={errorMessage}
      alignItems='center'
      {...props}
    />
  )
}
